/**
 * 2026-05-30 — Route guard for Player-self-signup accounts.
 *
 * Accounts created via the "Player" signup branch (persona_self_declared
 * === "player" AND no organization_id) can only see:
 *   • /me/player                — their hub (profile + stats)
 *   • /account/player-profile   — the profile editor (linked from hub)
 *   • /account/privacy          — DPDP rights (data export / deletion)
 *   • /find-a-player/*          — public marketplace (PublicLayout, ignored)
 *
 * Any other authenticated route bounces them back to /me/player. Backend
 * permissions are the real enforcement — this is defence-in-depth so the
 * page chrome doesn't flash before the in-page gate fires.
 */
import { Navigate, useLocation } from "react-router-dom";
import useAuthStore from "../../store/auth.store";


const PLAYER_ALLOWED_PATHS = [
  "/me/player",
  "/account/player-profile",
  "/account/privacy",
];


export function isPlayerAccount(user) {
  if (!user) return false;
  if (user.persona_self_declared !== "player") return false;
  // If they have an organization, treat them as a regular user even if
  // they self-declared "player" — the org tag wins.
  if (user.organization_id || user.organization) return false;
  return true;
}


export default function RequireNotPlayer({ children }) {
  const { user, loading } = useAuthStore();
  const { pathname } = useLocation();

  if (loading) return null;
  if (!isPlayerAccount(user)) return children;

  const allowed = PLAYER_ALLOWED_PATHS.some(
    (p) => pathname === p || pathname.startsWith(p + "/")
  );
  if (allowed) return children;
  return <Navigate to="/me/player" replace />;
}
